import React from 'react';
// RoadmapCard 컴포넌트 임포트 (상대 경로 사용)
import RoadmapCard from '../RoadmapCard';
import { InfiniteScrollList } from '@edusense/infinite-scroll';
import { StatusDisplay } from '@edusense/shared-ui-kit';
var RoadmapList = function(param) {
    var roadmaps = param.roadmaps, onRoadmapClick = param.onRoadmapClick, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, isLoading = param.isLoading, isFetchingNextPage = param.isFetchingNextPage, error = param.error, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage, observerRef = param.observerRef, _param_emptyStateContent = param.emptyStateContent, emptyStateContent = _param_emptyStateContent === void 0 ? '표시할 로드맵이 없습니다.' : _param_emptyStateContent, _param_isEditable = param.isEditable, isEditable = _param_isEditable === void 0 ? false : _param_isEditable, onEdit = param.onEdit, onDelete = param.onDelete, onReport = param.onReport;
    // 각 로드맵 아이템 렌더링
    var renderRoadmapItem = function(roadmap) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "roadmap-item",
            onClick: function() {
                return onRoadmapClick && onRoadmapClick(roadmap.id);
            }
        }, /*#__PURE__*/ React.createElement(RoadmapCard, {
            key: roadmap.id,
            roadmap: roadmap,
            onClick: onRoadmapClick,
            onReport: onReport
        }), isEditable && /*#__PURE__*/ React.createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '0.5rem',
                justifyContent: 'flex-end'
            }
        }, onEdit && /*#__PURE__*/ React.createElement("button", {
            onClick: function(e) {
                e.stopPropagation();
                onEdit(roadmap.id);
            },
            style: {
                padding: '0.25rem 0.5rem',
                backgroundColor: 'transparent',
                border: '1px solid var(--theme-border, #e5e7eb)',
                borderRadius: '0.25rem',
                fontSize: '0.75rem',
                color: 'var(--theme-text-secondary, #6b7280)',
                cursor: 'pointer'
            }
        }, "수정"), onDelete && /*#__PURE__*/ React.createElement("button", {
            onClick: function(e) {
                e.stopPropagation();
                onDelete(roadmap.id);
            },
            style: {
                padding: '0.25rem 0.5rem',
                backgroundColor: 'transparent',
                border: '1px solid var(--theme-border, #e5e7eb)',
                borderRadius: '0.25rem',
                fontSize: '0.75rem',
                color: 'var(--theme-text-secondary, #6b7280)',
                cursor: 'pointer'
            }
        }, "삭제")));
    };
    // 무한 스크롤을 사용하는 경우
    if (observerRef) {
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, /*#__PURE__*/ React.createElement(InfiniteScrollList, {
            items: roadmaps,
            renderItem: renderRoadmapItem,
            isLoading: isLoading,
            isFetchingNextPage: isFetchingNextPage,
            error: error,
            hasNextPage: hasNextPage,
            fetchNextPage: fetchNextPage,
            observerRef: observerRef,
            emptyStateContent: emptyStateContent
        }));
    }
    // 기본 로드맵 목록 (무한 스크롤 없는 경우)
    if (!roadmaps || roadmaps.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "roadmap-list-empty ".concat(className)
        }, /*#__PURE__*/ React.createElement(StatusDisplay, {
            type: "empty",
            message: emptyStateContent
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "roadmap-list ".concat(className),
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, roadmaps.map(function(roadmap) {
        return renderRoadmapItem(roadmap);
    }));
};
export default RoadmapList;
